import { createAction } from 'redux-act';

const MODULE_ID = 'FD_COOKIE_CONSENT_';

const createCookieConsentAction = <T>(type: string) =>
  createAction<T>(`${MODULE_ID}${type}`);

export const setCookieConsent =
  createCookieConsentAction<WebOrder.State.CookieConsent['selectedGroups']>(
    'SET_COOKIE_CONSENT',
  );
export const setRememberMe =
  createCookieConsentAction<WebOrder.State.CookieConsent['rememberMe']>(
    'SET_REMEMBER_ME',
  );
